import { IntlShape } from 'react-intl';

interface IResult {
  fieldCannotBeEmpty: string;
  onlyLatinLettersAndNumbers: string;
  allowedNumberCharacters: string;
  emailNotValid: string;
  phoneNotValid: string;
}
type TGetErrorMessages = (formatMessage: IntlShape['formatMessage']) => IResult;

const getErrorMessages: TGetErrorMessages = (formatMessage) => ({
  fieldCannotBeEmpty: formatMessage({ id: "error.fieldCannotBeEmpty" }),
  onlyLatinLettersAndNumbers: formatMessage({ id: "error.onlyLatinLettersAndNumbers" }),
  allowedNumberCharacters: formatMessage({ id: "error.allowedNumberCharacters" }),
  emailNotValid: formatMessage({ id: "erorr.emailNotValid" }),
  phoneNotValid: formatMessage({ id: "error.phoneNotValid" })
});

export default getErrorMessages;
